import React from 'react'

import { ip } from "../../config";
import SpinLoader from "../Miscel/SpinLoader";
import { useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import {useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
const Login = ({setReloadNavbar}) => {  
    
    
    let navigate = useNavigate();
    useEffect(() => {
        document.getElementById("spinloader").classList.add("invisible");
        if(localStorage.getItem("sessionKey")!=null && localStorage.getItem("sessionKey")!=undefined && localStorage.getItem("sessionKey")!=""){
            window.location.href="/";
        }
    },[]);
    
    function Login(e) {
        e.preventDefault();

        const notify = (message) => toast.success(message,{position: "top-center"});
                
        const username = document.getElementById('username').value;
        const password = document.getElementById('password').value;                

        var headers = new Headers();
        headers.append('Authorization', 'Basic ' + btoa(username + ':' + password));
        headers.append('content-type','application/json')

        fetch(ip+'/users/authcheck', {  
            headers: headers,                                                        
            method: 'GET',                                     
        }).then(res => {
            if(res.status===200){
                notify("Login Successful, Redirecting...");
                setReloadNavbar(new Date().toDateString());
                return res.json();                
            }else if(res.status===401){
                throw new Error("Username or password incorrect")
            }            
        })
        .then(res => {
            localStorage.setItem("sessionKey",btoa(username + ':' + password));
            localStorage.setItem("type",res["role"]);
            setTimeout(() => {
                navigate("/", { replace: true });    
            }, 2000);
            

        })
        .catch(err => {
            console.log(err)
        })
    }

    return ( 
        <div className=" d-flex align-items-center justify-content-center" >
            <SpinLoader/>
            <ToastContainer/>
        <div className="container mt-5" >
            <div className="row">
                <div className="col-md-6 offset-md-3">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Login</h3>
                        </div>
                        <div className="card-body">
                            <form>
                                <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">Username:</label>
                                    <input type="text" id="username" className="form-control"  aria-describedby="emailHelp" placeholder="Enter email" />                                                                        
                                </div>
                                <br />
                                <div className="form-group">
                                    <label htmlFor="exampleInputPassword1">Password:</label>
                                    <input id="password" type="password" className="form-control" placeholder="Password" />
                                </div>                                
                                <button type="submit" onClick={(e) => Login(e)} className="btn btn-primary mt-2">Login</button>                                
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>

     );
}
 
export default Login;